import * as React from 'react';

import { cn, IconButton } from '@rematter/ui-web';
import { LucideCamera } from 'lucide-react';

import { ItemFieldProps } from '../_types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

//
// ⚛️ ⚛️ ⚛️ CAMERA BUTTON FIELD ⚛️ ⚛️ ⚛️
//
export const CameraButtonField: React.FC<ItemFieldProps> = ({
  lineItem: _lineItem,
  disabled,
}) => {
  const t = useTranslations();

  return (
    <div className="@CameraButtonField">
      <div className="relative inline-block h-full">
        <IconButton
          icon={<LucideCamera size={18} className="text-neutral/60" />}
          className="size-input h-full"
          isDisabled={disabled}
          variant="ghost"
          aria-label={t.scaleTicketPro.itemsInterface.takePhoto}
        />
        <div
          className={cn(
            'absolute top-2 right-2 size-[6px] rounded-full border-[0.5px] border-white bg-primary',
            disabled && 'bg-failure',
          )}
        />
      </div>
    </div>
  );
};
